module.exports = __webpack_public_path__ + "img/renewable-energy.54ec7e44.png";